import BasicSlider from './BasicSlider';

export default class FrontpageSlider extends BasicSlider {
  constructor($el, config) {
    super($el, config);
    this.init();
  }

  init() {
    this.$el.addEventListener('after.lory.init', () => {
      this.sizeFrontpageSlides();
    });

    this.$el.addEventListener('before.lory.init', () => {
      this.sizeFrontpageSlides();
    });

    this.$el.addEventListener('on.lory.resize', () => {
      this.sizeFrontpageSlides();
    });

    window.addEventListener('selectTab', () => {
      this.sizeFrontpageSlides();
    });
  }

  setContainerHeight() {
    this.sizeFrontpageSlides();
    super.setContainerHeight();
  }

  // get biggest frontpage headers height
  calculateFrontpageSlideHeight() {
    let contentHeight = 0;

    this.$slides.forEach(($slide) => {
      const $content = $slide.querySelector('.frontpage-header__contentwrap');
      if ($content) {
        if ($content.clientHeight > contentHeight) {
          contentHeight = $content.clientHeight;
        }
      }
    });

    return contentHeight;
  }

  // calculate the arrow positions depending on images
  positionArrows() {
    const $activeSlide =
      this.$el.querySelector('.slider__slide.active') || this.$el.querySelector('.slider__slide');

    if ($activeSlide) {
      const $activeSlideImage = $activeSlide.querySelector('.figure__media .image');

      this.$controlPrev.style.top = `${$activeSlideImage.offsetTop + ($activeSlideImage.clientHeight / 2)}px`;
      this.$controlNext.style.top = `${$activeSlideImage.offsetTop + ($activeSlideImage.clientHeight / 2)}px`;
    }
  }

  // set a specific height for all frontpage headers
  // inside the slider to prevent content jumping
  // add fallback styling if no content is added
  sizeFrontpageSlides() {
    this.$slides.forEach(($slide) => {
      const $content = $slide.querySelector('.frontpage-header__contentwrap');
      const $frontpageSlide = $slide.querySelector('.frontpage-header');

      if ($content) {
        $content.removeAttribute('style');
        $content.style.height = `${this.calculateFrontpageSlideHeight()}px`;
      } else if ($frontpageSlide) {
        $frontpageSlide.removeAttribute('style');
        $frontpageSlide.setAttribute('style', 'padding-bottom: 2rem');
      }
    });
  }
}
